import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { assetUrl } from 'src/single-spa/asset-url';
import {DocumentosService} from '~core/api/documentos.service';
import {DocumentoReferencia} from '~shared/components/rota-detalhes-dialog/rota-detalhes-dialog.component';

@Component({
  selector: 'app-rota-detalhes-documentos',
  templateUrl: './rota-detalhes-documentos.component.html',
  styleUrls: ['./rota-detalhes-documentos.component.scss'],
  providers: [DocumentosService],
})
export class RotaDetalhesDocumentosComponent {
  @Input() loaded$!: BehaviorSubject<boolean>;
  @Input() documentos$!: BehaviorSubject<DocumentoReferencia[]>;
  @Input() viewMode: 'list' | 'image' = 'list';
  @Output() downloadFile$: EventEmitter<DocumentoReferencia> = new EventEmitter();

  // Propriedades para controle de ordenação
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  // Método para ordenação das colunas
  sortBy(column: string): void {
    console.log('Ordenando por:', column, 'Direção atual:', this.sortDirection);

    if (this.sortColumn === column) {
      // Se já está ordenando por esta coluna, inverte a direção
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Nova coluna selecionada
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    console.log('Nova direção:', this.sortDirection, 'Coluna:', this.sortColumn);

    // Aplica a ordenação aos documentos
    const currentDocuments = this.documentos$.value;
    if (!currentDocuments || currentDocuments.length === 0) {
      console.log('Nenhum documento para ordenar');
      return;
    }

    console.log('Documentos antes da ordenação:', currentDocuments.length);

    const sortedDocuments = [...currentDocuments].sort((a, b) => {
      let valueA: any;
      let valueB: any;

      switch (column) {
        case 'visita':
          valueA = parseInt(a.pedido.ordem.toString()) || 0;
          valueB = parseInt(b.pedido.ordem.toString()) || 0;
          break;
        case 'tipo':
          valueA = (a.tipo || '').toLowerCase();
          valueB = (b.tipo || '').toLowerCase();
          break;
        case 'status':
          valueA = (a.statusKey || '').toLowerCase();
          valueB = (b.statusKey || '').toLowerCase();
          break;
        case 'registro':
          valueA = new Date(a.arquivo.data).getTime();
          valueB = new Date(b.arquivo.data).getTime();
          break;
        default:
          return 0;
      }

      // Comparação baseada no tipo
      let result = 0;
      if (valueA < valueB) {
        result = -1;
      } else if (valueA > valueB) {
        result = 1;
      }

      // Aplica a direção da ordenação
      return this.sortDirection === 'asc' ? result : -result;
    });

    console.log('Documentos após ordenação:', sortedDocuments.length);

    // Força a atualização do BehaviorSubject
    this.documentos$.next(sortedDocuments);
  }

  assetUrl(url: string) {
    return assetUrl(url);
  }

  download(referencia: DocumentoReferencia): void {
    this.downloadFile$.emit(referencia);
  }

  openDocument(referencia: DocumentoReferencia): void {
    window.open(referencia.arquivo.linkView, '_blank');
  }

  downloadDocument(referencia: DocumentoReferencia): void {
    window.open(referencia.arquivo.linkDownload, '_blank');
  }
}
